<template>
  <v-card min-width="21vw" light outlined>
    <v-card-title class="text-center" style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>Add Coupon</h2></v-list-item-title>
        <v-spacer/>
        <v-icon class="icon" @click="close">fa-times</v-icon>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <v-form v-model="valid">
        <v-text-field label="Coupon Name" placeholder="E.g. GWT" v-model="couponName" :rules="nameRules" outlined/>
        <v-text-field label="Max Coupon Limits" placeholder="E.g. 100" v-model="maxCount" :rules="maxCountRules" type="number" outlined/>
        <v-autocomplete label="Coupon Owner" :items="$store.state.users" item-text="user.email"
                        item-value="user.id" placeholder="E.g. jc@swiset.com" v-model="owner" :rules="ownerRules" outlined/>
        <v-text-field label="Discount Percentage" placeholder="E.g. 10" :disabled="true" v-model="discount" outlined/>
        <v-btn :disabled="!valid" @click="addCoupon">Add Coupon</v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/payments';
export default {
  name: "AddCoupon",
  data() {
    return {
      valid: false,
      couponName: '',
      maxCount: '',
      owner: 0,
      discount: 10,

      nameRules: [
        n => !!n || 'Name is required',
      ],
      maxCountRules: [
        c => !!c || 'Max Limit is required',
        c => Number(c) > 0 || 'Max Limit should be higher than 0',
      ],
      ownerRules: [
        o => !!o || 'Owner is required',
      ],
    };
  },
  methods: {
    addCoupon() {
      let coupon = {
        userId: Number(this.owner),
        maxCount: Number(this.maxCount),
        couponName: this.couponName,
        discountPercentage: Number(this.discount),
      };

      Repository.createCoupon(coupon).then((response) => {
        if(response.status < 400) {
          alert('Coupon created successfully!');
          this.$emit('created');
        }
      });
    },
    close() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>

</style>
